import {Alerts} from "../Alerts";
import {Forms} from "./Forms";

export class FormOnError {

    static productValidationErrors(form, data)
    {
        if (!data || !data.errors) {
            return;
        }

        $('.tabError').removeClass('tabError');

        Object.keys(data.errors).forEach(name => {

            let $element, $input = Forms.findErrorInput(name, form);


            $("[href='#"+ $input.parents('.tab-pane').prop('id') +"']").addClass('tabError');

        //     if (name.indexOf('.') <= -1) {
        //         $element = $(`[name='${name}']`);
        //     }
        //     else {
        //         let arr = name.split('.');
        //         let numberOfDots = (name.match(/\./g) || []).length;
        //         let elementSelection = `[name='${arr[0]}`;
        //
        //         for (let i = 1; i <= numberOfDots; i++) {
        //             elementSelection = elementSelection.concat(`[${arr[i]}]`)
        //         }
        //
        //         elementSelection = elementSelection.concat("']");
        //
        //         console.log(elementSelection, 'selection')
        //
        //         $element = $(elementSelection)
        //
        //     }
        //     let $tabPane = $element.closest('.tab-pane');
        //     $(`[href='#${$tabPane.attr('id')}']`).addClass('tabError');
        })
        Alerts.error('Input Errors Occurred');
    }
}
